import { ComponentProps } from 'lib/component-props';
import useHelpers from 'hooks/helpers';
import { useSitecoreContext } from 'hooks/useSitecoreContext';
import { useMemo } from 'react';
import Articles from 'components/Sections/TableOfContents/Articles';
import Sidebar from 'components/Sections/TableOfContents/Sidebar';
import { FieldsType } from 'model/TableOfContents';

type Props = ComponentProps & {
  fields: FieldsType;
};

const TableOfContents = ({ rendering, fields }: Props): JSX.Element => {
  const { anchorId } = useHelpers(rendering);
  const { sitecoreContext } = useSitecoreContext();

  const content = useMemo(() => {
    const { items } = fields;
    const content = items.map((article, i) => {
      // to enable scrolling in frontend mode
      return {
        ...article,
        fields: {
          ...article.fields,
          items: article.fields.items
            ? article.fields.items.map((item, index) => {
                return {
                  ...item,
                  id: item.id + i + index + 'subtitle',
                };
              })
            : [],
        },
        id: article.id + i + 'title',
      };
    });
    return { ...fields, items: content };
  }, [fields]);

  const dataSource = useMemo(() => {
    return sitecoreContext.pageEditing ? fields : content;
  }, [sitecoreContext.pageEditing, fields, content]);

  return (
    <section
      id={anchorId}
      data-e2e-component-uid={rendering.uid}
      className="container default-section-padding"
    >
      <div className="row d-flex flex-column flex-xl-row">
        {dataSource && (
          <>
            <Sidebar fields={dataSource} />
            <Articles className="col-12 col-xl-9" articles={dataSource} />
          </>
        )}
      </div>
    </section>
  );
};

export default TableOfContents;
